import Countdown from "react-countdown";
import "./CountdownClock.css";

const CountdownClock = ({ date, theme }) => {
  let nextDate = new Date(date);

  const margin = theme === "dark" ? "mt-2" : "-mt-[5px]";

  return (
    <Countdown
      date={nextDate}
      renderer={(props) => (
        <div className={`countdown ${theme} ${margin} `}>
          <div className="br-1 border-white">
            {props.days}
            <span className={theme}>Days</span>
          </div>
          <div>
            {props.hours}
            <span className={theme}>Hrs</span>
          </div>
          <div>
            {props.minutes}
            <span className={theme}>Mins</span>
          </div>
          <div aria-live="off" aria-hidden="true">
            {props.seconds}
            <span className={theme}>Secs</span>
          </div>
        </div>
      )}
    />
  );
};

export default CountdownClock;
